export const removeItemArray = (arr, value) => {
    return arr.filter((item) => {return item !== value});
}
export const removeItemArrayByIndex = (arr, index) => {
    const temp = arr;
    temp.splice(index, 1);
    return temp;
}